function getRequestPayload(username) {
    return {
        operationName: 'VendorUserBrands',
        query:
            'query VendorUserBrands($username: String, $first: Int) {userBrands(brand_Vendor_User_Username: $username, first: $first) { totalCount, edges { node { id, description, reply, createdTime, user { id, username, href, profile { id, sex, avatar { id, srcset, src }}}}}}}',
        variables: {
            first: 8,
            username: username,
        },
    };
}

function init(countryCode, username, width, height) {
    var xhr = new XMLHttpRequest();
    var host = countryCode === 'sk' ? 'https://beta.mojasvadba.zoznam.sk' : 'https://www.beremese.cz';

    xhr.onload = function () {
        var data = JSON.parse(xhr.responseText);
        render(username, host, countryCode, data, width, height);
    };

    xhr.open('POST', host + '/graphql');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify(getRequestPayload(username)));
}

function render(vendorUsername, host, countryCode, data, width, height) {
    var root = document.getElementById('recom-widget-root');
    root.style =
        'overflow-y: auto; padding: 10px; border: 1px solid #e5e5e5; border-radius: 10px; width: ' +
        width +
        'px;' +
        'height: ' +
        height +
        'px;';

    var header = document.createElement('div');
    header.style =
        'display: -webkit-box; display: -ms-flexbox; display: flex; margin-bottom: 10px; -webkit-box-align: center; -ms-flex-align: center; align-items: center;';

    var headerLeft = document.createElement('div');
    headerLeft.innerHTML = countryCode === 'sk' ? 'Odporúčania z mojasvadba.sk' : 'Doporučení z beremese.cz';
    headerLeft.style = 'font-size: 12px; font-weight: 600; line-height: 15px; color: #c12d5a;';

    var headerLogo = document.createElement('img');
    headerLogo.style = 'width: 65px; height: auto;';
    headerLogo.src =
        countryCode === 'sk'
            ? 'http://static.4nets.sk/images/wedding-sk-logo.svg'
            : 'http://static.4nets.sk/images/wedding-cz-logo.svg';

    var headerRight = document.createElement('a');
    headerRight.href = countryCode === 'sk' ? 'https://beta.mojasvadba.zoznam.sk' : 'https://beremese.cz';
    headerRight.appendChild(headerLogo);

    header.appendChild(headerLeft);
    header.appendChild(headerRight);

    root.innerHTML = '';
    root.appendChild(header);
    data.data.userBrands.edges.forEach(function (edge) {
        root.appendChild(createRecomElement(edge.node, countryCode));
    });

    var linkButton = document.createElement('a');
    linkButton.href = host + '/catalog/vendor/' + vendorUsername + '#?tab-vendor-info-recoms';
    linkButton.style = 'text-decoration: none;';
    var button = document.createElement('div');
    button.style =
        'text-align: center; background-color: #c12d5a; border-radius: 8px; margin-top: 20px; padding: 10px; color: white; font-size: 11px;';
    button.innerHTML = 'Zobraz všetky odporúčania (' + data.data.userBrands.totalCount + ')';
    linkButton.appendChild(button);
    root.appendChild(linkButton);
}

function createRecomElement(recomNode, countryCode) {
    var root = document.createElement('div');
    root.style = 'border-top: 1px solid #e5e5e5; padding: 5px 0;';

    var user = document.createElement('div');
    user.style = 'display: -webkit-box; display: -ms-flexbox; display: flex;';

    var info = document.createElement('div');
    info.style = 'margin: auto 0;';

    var username = document.createElement('div');
    username.style = 'font-size: 12px; font-weight: 600; line-height: 20px; color: #323232;';

    var date = document.createElement('div');
    date.style = 'font-size: 11px; line-height: 12px; color: #8e8e8e;';

    var avatarImg = document.createElement('img');
    avatarImg.style = 'width: 35px; height: 35px; border-radius: 5px; margin-right: 4px;';
    if (recomNode.user.profile.avatar) {
        avatarImg.src = recomNode.user.profile.avatar.src;
        avatarImg.srcset = recomNode.user.profile.avatar.srcset;
    } else {
        avatarImg.src =
            recomNode.user.profile.sex === 1
                ? 'http://static.4nets.sk/images/female.png'
                : 'http://static.4nets.sk/images/male.png';
    }

    var desc = document.createElement('p');
    desc.style = 'font-size: 11px; color: #323232; line-height: 13px; margin: 6px 0 0 0;';
    desc.innerHTML = recomNode.description ? recomNode.description : countryCode === 'sk' ? 'odporúča' : 'doporučuje';

    user.appendChild(avatarImg);
    user.appendChild(info);
    info.appendChild(username);
    info.appendChild(date);
    username.append(recomNode.user.username);

    var d = new Date(recomNode.createdTime);

    date.append(d.getDate().toString() + '.' + (d.getMonth() + 1).toString() + '.' + d.getFullYear().toString());

    root.appendChild(user);
    root.append(desc);

    return root;
}

function ready(callbackFunction) {
    if (document.readyState != 'loading') {
        callbackFunction();
    } else {
        document.addEventListener('DOMContentLoaded', callbackFunction);
    }
}

if (
    typeof window !== 'undefined' &&
    window.location.host !== 'www.beremese.cz' &&
    window.location.host !== 'beta.mojasvadba.zoznam.sk'
) {
    ready(function () {
        var hostParts = window.location.host.split('.');
        var countryCode = hostParts[hostParts.length - 1];
        var script = document.getElementById('recom-widget-script');
        if (!script) {
            return;
        }
        var src = script.src;
        var parts = src.split('?');
        var urlParts = parts[0].split('/');
        var username = urlParts[urlParts.length - 1];
        var m = parts[1].match(/width=([0-9]+)&height=([0-9]+)/);

        if (m) {
            init(countryCode, username, m[1], m[2]);
        }
    });
}

module.exports = init;
